import React from "react";
import DataCard from "./Card";
import impactData from "./data";
import styles from "./Impact.module.css";
import { useColorModeValue } from "../../hooks/useColorModeValue";

const Impact  = () => {
  const marqetext = [
    { text: "Join our tech community", color: "#dc362e" },
    { text: "Earn Google badges", color: "#1b6ef3" },
    { text: "Build apps with Flutter", color: "#f09d00" },
    { text: "Attend campus events", color: "#dc362e" },
    { text: "Explore Google Cloud", color: "#202124" },
    { text: "Follow #GDGOnCampus", color: "#1b6ef3" },
    { text: "Discover AI and ML", color: "#f09d00" },
    { text: "Create web experiences", color: "#dc362e" },
    { text: "Connect with developers", color: "#1b6ef3" },
    { text: "Learn Android development", color: "#202124" },
    { text: "Meet industry experts", color: "#f09d00" },
];
  return (
    <>
      <div className={styles["container"]}>
        <div className={styles["heading"]}>
          <h1 style={{ color: useColorModeValue("#505050", "#ffffff") }}>
            See The Impact We Create
          </h1>
        </div>
        <div className={styles["content"]}>
          <div className={styles["data-cards"]}>
            {impactData.map((card, index) => {
              return (
                <DataCard index={index} key={card.id} {...card}></DataCard>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles["marqueeAnimContainer"]}>
        <div className={styles["marqueeAnim"]}>
          <div>
            {marqetext.map((text, index) => {
              return (
                <span key={index} style={{ backgroundColor: text.color }}>{text.text}</span>
              );
            })}
          </div>
          <div>
            {marqetext.map((text, index) => {
              return (
                <span key={index} style={{ backgroundColor: text.color }}>{text.text}</span>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Impact ;
